
// bootstrap code goes here
import React, {Component} from 'react';
import ReactDOM from 'react-dom';
//import Ws from 'ws';


// jquery library
// import JQuery from 'jquery';

// window.$ = window.jQuery = JQuery;

// Object.assign: babel-plugin-object-assign
// require('object-assign');
var Moment = require('moment');
Moment.locale('pl'  );

var momentLocalizer = require('react-widgets/lib/localizers/moment')
momentLocalizer(Moment);

// this will add summing offset parent to properties
window.Object.defineProperty(Element.prototype, 'documentOffsetTop', {
  get: function () {
    return this.offsetTop + (this.offsetParent ? this.offsetParent.documentOffsetTop : 0);
  }
});

window.Object.defineProperty(Element.prototype, 'documentOffsetLeft', {
  get: function () {
    return this.offsetLeft + (this.offsetParent ? this.offsetParent.documentOffsetLeft : 0);
  }
});

import Ajax from 'app/react/data/Ajax.jsx';
import AppBase from 'app/react/AppBase.jsx';
import DataStore from 'app/react/data/DataStore.jsx';

// i think this is not necessary
//import createFragment from 'react-addons-create-fragment';
import EventTracker from 'app/react/tools/EventTracker.jsx';

// this is for date manipulation
//require("date-format-lite")
var TinyColor = require('app/libs/tinycolor-min.js');
var DOMTools = require('app/react/tools/DOMTools.jsx');

//  import Wawa from 'app/react/WawaUtils.jsx';

//import ParSelector from './daily/ParSelector.jsx';
// if test version
// bower css for testing

//require('../../bower_components/bootstrap/dist/css/bootstrap.min.css')

module.exports = {

  // basic lib components
  'React': React,
  'ReactDOM': ReactDOM,
  'Component': Component,
//  'JQuery': JQuery,
  'Moment': Moment,

  // basic app component
  'Ajax': Ajax,
  'AppBase': AppBase,
  'DataStore': DataStore,

  // other libraries
  'EventTracker': EventTracker,
  'TinyColor': TinyColor,
  'DOMTools': DOMTools,

  // websockets
  //'Ws': Ws

  // wawa utils
  //'Wawa': Wawa
}



// WEBPACK FOOTER //
// ./app/react/Boot.jsx